import {gql} from '@apollo/client'


export const accountRegisterMutation = gql`
  mutation AccountRegister($email: String!, $password: String!, $redirectUrl: String) {
    accountRegister(
      input: {
        email: $email,
        password: $password,
        redirectUrl: $redirectUrl,
      }
    ) {
      accountErrors {
        field
        code
      }
      user {
        email
        isActive
      }
    }
  }
`
